import {createApiResource} from 'data/utils';

const resource = createApiResource({
	name: 'list',
	pathName: '/lists',
	unwrap: x => x,
});

export const queryClientHelpers = resource.createQueryClientHelpers();
export const useLists = resource.createUseQueryIndex();
export const useList = resource.createUseQueryById();
